import './App.css';
import { useEffect, useState } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import NavigationBar from './components/NavigationBar';
import Home from './pages/Home';
import Rooms from './pages/Rooms';
import RoomDetail from './components/RoomDetail';
import Contacts from './pages/Contacts';
import ScrollTop from './components/ScrollTop';
import Gallery from './pages/Gallery';
import Footer from './components/Footer';

function App() {
	const location = useLocation();

	const [coffeeIconInvisible, setCoffeeIconInvisible] = useState(
		location.pathname === '/' && window.scrollY < 60
	);

	useEffect(() => {
		function handleScroll() {
			if (location.pathname === '/' && window.scrollY < 60) {
				setCoffeeIconInvisible(true);
			} else {
				setCoffeeIconInvisible(false);
			}
		}

		// Run on mount and when location changes
		handleScroll();

		window.addEventListener('scroll', handleScroll);
		return () => {
			window.removeEventListener('scroll', handleScroll);
		};
	}, [location.pathname]);

	return (
		<>
			<ScrollTop />
			<NavigationBar />
			<div
				style={{
					position: 'relative',
					zIndex: 2,
					backgroundColor: '#fff',
				}}
			>
				<Routes>
					<Route path="/" element={<Home />} />
					<Route path="rooms" element={<Rooms />} />
					<Route path="room/:name" element={<RoomDetail />} />
					<Route path="quadra-island" element={<Gallery />} />
					<Route path="contact" element={<Contacts />} />
				</Routes>
			</div>
			<Footer />
			<img
				id="coffee-icon"
				title="Coming Soon!"
				src="/coffee-icon.gif"
				alt="Coffee Icon"
				style={{
					display: coffeeIconInvisible ? 'none' : 'block',
				}}
			/>
		</>
	);
}

export default App;
